module.exports = __webpack_public_path__ + "32872f6da6f6702c1c841f99339fb687.pdf";